import axios from 'axios';

interface SignLifewayConsultantData {
  contractId: string;
}

export const signLifewayConsultant = async (data: SignLifewayConsultantData) =>
  axios
    .post(`${process.env.REACT_APP_LIFEWAY_API_URL}/consultant/sign-registration`, data)
    .then((response) => response.data);
